// @ts-nocheck
import { populate } from 'populate';
import type { Container } from 'pixi.js';

const raw = {
  list: [
    {
      id: '4edf286d-6620-4335-b47b-eb0996595931',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: '65463ab4-47fb-408e-a8d8-efb9894c929f',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 147,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Game',
      parent: '4edf286d-6620-4335-b47b-eb0996595931',
      data: {
        DEBUG: true
      }
    },
    {
      id: '6e81cb93-1188-4176-9677-c4a3627e74a3',
      type: 'Container',
      name: 'fireworkSlot1',
      className: '',
      x: -172,
      y: -198,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '4edf286d-6620-4335-b47b-eb0996595931'
    },
    {
      id: '5861afa6-5618-4b16-8fb7-c125d1a949c5',
      type: 'Container',
      name: 'fireworkSlot2',
      className: '',
      x: 175,
      y: -124,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '4edf286d-6620-4335-b47b-eb0996595931'
    },
    {
      id: 'b0942069-7c8b-405d-bb33-5d124dd67843',
      type: 'Container',
      name: 'fireworkSlot3',
      className: '',
      x: 115,
      y: 60,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '4edf286d-6620-4335-b47b-eb0996595931'
    },
    {
      id: '657f95c8-707d-4404-be52-18acf1d40fc6',
      type: 'Container',
      name: 'fireworkSlot4',
      className: '',
      x: -133,
      y: 115,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '4edf286d-6620-4335-b47b-eb0996595931'
    },
    {
      id: '7f7335a4-e876-4e64-934c-a32c6ae15b03',
      type: 'Container',
      name: 'fireworkSlot5',
      className: '',
      x: 60,
      y: -69,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '4edf286d-6620-4335-b47b-eb0996595931'
    },
    {
      id: '2c748fee-898d-4e49-a88d-2d274c0905ad',
      type: 'Container',
      name: 'fireworkSlot6',
      className: '',
      x: -167,
      y: -94,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '4edf286d-6620-4335-b47b-eb0996595931'
    },
    {
      id: 'e7c084fd-3932-48b4-8825-fbd3fc1e8ceb',
      type: 'Container',
      name: 'fireworkSlot7',
      className: '',
      x: -120,
      y: 165,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '4edf286d-6620-4335-b47b-eb0996595931'
    },
    {
      id: '8ce77931-fdd7-4f8c-b48d-eb931bbdc2ab',
      type: 'Container',
      name: 'fireworkSlot8',
      className: '',
      x: 132,
      y: 103,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '4edf286d-6620-4335-b47b-eb0996595931'
    }
  ],
  x: 0,
  y: 0,
  width: 760,
  height: 760,
  version: '3.1.0',
  animations: [
    {
      id: '919c035b-42e5-4f4c-ae9e-a20a652883fe',
      name: 'Fireworks',
      playingSpeed: 1,
      totalDuration: 1200,
      blocks: [
        {
          id: 'f436d1e4-a9ee-48c7-b4f8-3bfa2ffb66dd',
          type: 'Setter',
          name: 'FXPART_Fireworks_Blue',
          track: 7,
          target: {},
          startAt: 1,
          sourceName: 'fireworkSlot1',
          disabled: false
        },
        {
          id: '36d26913-38f3-4e73-94e9-32423b5e5566',
          type: 'Setter',
          name: 'FXPART_Fireworks_Pink',
          track: 6,
          target: {},
          startAt: 191,
          sourceName: 'fireworkSlot2',
          disabled: false
        },
        {
          id: '05d1a69e-abcb-4bd7-8ffd-37087feaf847',
          type: 'Setter',
          name: 'FXPART_Fireworks_Yellow',
          track: 5,
          target: {},
          startAt: 321,
          sourceName: 'fireworkSlot3',
          disabled: false
        },
        {
          id: 'f172b9eb-be07-45c5-b136-e3fb687c0668',
          type: 'Setter',
          name: 'FXPART_Fireworks_Green',
          track: 4,
          target: {},
          startAt: 420,
          sourceName: 'fireworkSlot4',
          disabled: false
        },
        {
          id: '031f6c11-bd96-4d2a-9df6-301db817f304',
          type: 'Setter',
          name: 'FXPART_Fireworks_Blue',
          track: 3,
          target: {},
          startAt: 510,
          sourceName: 'fireworkSlot5',
          disabled: false
        },
        {
          id: '64f0ca9a-9b38-452d-8161-a82d546d7ac6',
          type: 'Setter',
          name: 'FXPART_Fireworks_Pink',
          track: 2,
          target: {},
          startAt: 633,
          sourceName: 'fireworkSlot6',
          disabled: false
        },
        {
          id: '15438f6e-bc54-4209-a59d-6bd4c54a8452',
          type: 'Setter',
          name: 'FXPART_Fireworks_Green',
          track: 3,
          target: {},
          startAt: 726,
          sourceName: 'fireworkSlot8',
          disabled: false
        },
        {
          id: 'c616a526-14ec-46d8-a6e0-62f8cd80f99d',
          type: 'Setter',
          name: 'FXPART_Fireworks_Yellow',
          track: 4,
          target: {},
          startAt: 826,
          sourceName: 'fireworkSlot7',
          disabled: false
        }
      ]
    }
  ],
  handleResize: false
} as const;

export class BoardFireworksAnimationLayout {
  static raw = raw;
  root!: Container;
  fireworkSlot1!: Container;
  fireworkSlot2!: Container;
  fireworkSlot3!: Container;
  fireworkSlot4!: Container;
  fireworkSlot5!: Container;
  fireworkSlot6!: Container;
  fireworkSlot7!: Container;
  fireworkSlot8!: Container;
  StateName!: never;

  constructor() {
    populate(this, raw);
  }
}

export abstract class Fireworks {
  Layout: {
    fireworkSlot1: object;
    fireworkSlot2: object;
    fireworkSlot3: object;
    fireworkSlot4: object;
    fireworkSlot5: object;
    fireworkSlot6: object;
    fireworkSlot8: object;
    fireworkSlot7: object;
  };

  BlockTypeByName: {
    FXPART_Fireworks_Blue: object;
    FXPART_Fireworks_Pink: object;
    FXPART_Fireworks_Yellow: object;
    FXPART_Fireworks_Green: object;
    FXPART_Fireworks_Blue: object;
    FXPART_Fireworks_Pink: object;
    FXPART_Fireworks_Green: object;
    FXPART_Fireworks_Yellow: object;
  };

  flowData = raw.animations[0];
}
